<template>
  <div class="bullets-steps_ver">
    <div 
      class="step"
      v-for="index in (this.totalSteps > 0 ? this.totalSteps-1 : 0)" 
      :key="index"
      :class="{'done': index <= activeStep}"
    >
      <span class="circle">{{index}}</span>
      <span 
        class="line"
        :class="{'done': index < activeStep}"
      ></span>
    </div>
    <div 
      class="step"
      :class="{'done': this.totalSteps == this.activeStep}"
    >
      <span class="circle">{{this.totalSteps}}</span>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";
import InputDash from "@/components/base/InputDash.vue";

export default {
  components: {
    BaseIcon, 
    InputDash,
  },
  computed: {
  },
  props: {
    height: String,
    totalSteps: Number,
    currentStep: Number,
    hasLabels: Boolean
  },
  data() {
    return{
      activeStep: 1
    }
  },
  methods: {

  },
  mounted() {
    this.activeStep = this.currentStep
  },
  watch: {
    currentStep: function(val) {
      this.activeStep = this.currentStep
    },
  }
};
</script>

<style lang="scss" scoped>  
@import "@/style/base";
@import "@/style/components/sideBox";
@import "@/style/components/inputs";
@import "@/style/components/buttons";
@import "@/style/components/stepBullets";

.side_box {
  max-height: 690px;
  
  label {
    height: 20px;
  }

  input, span{
    height: 30px;
    margin-bottom: 15px;
  }
}
</style>
